import React, { useState, useEffect } from "react";
import api from "../../services/api";
import serverHost from "../../services/serverHost";
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ThemeProvider,
  Typography,
} from "@mui/material";
import { createTheme } from "@mui/material";

import ReplyIcon from "@mui/icons-material/Reply";
import ForumIcon from "@mui/icons-material/Forum";
import { useHistory } from "react-router-dom";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CustomizedSnackbars from "../../components/alert/Alert";

let title = "";
let subtitle = "";
let subsubtitle = "";
let playAudio = "";
let text = "";
let tipo = "";

export default function Pronuncias({ dados }) {
  const history = useHistory();
  const [alerta, setAlerta] = useState(false);
  const [listaPronuncias, setListaPronuncias] = useState([]);
  const [play, setPlay] = useState(false);

  useEffect(() => {
    carregarPronuncias();
  }, []);

  const carregarPronuncias = () => {
    api
      .get("unidades/listarPronuncias", { unidadeId: dados.unidadeId })
      .then((res) => {
        setListaPronuncias(res);
      })
      .catch((e) => {
        text =
          "Não foi possível obter as unidades. Verifique sua conexão e tente novamente.";
        tipo = "error";
        alertMsg();
      });
  };

  const handleClose = () => {
    setPlay(false);
  };

  const abrirAcompanhamento = (pronu) => {
    let dadosUnidade = pronu;

    dadosUnidade.cicloNome = dados.cicloNome;
    dadosUnidade.disponivelAte = dados.disponivelAte;
    dadosUnidade.unidadeTitulo = dados.unidadeTitulo;
    dadosUnidade.unidadeNumero = dados.unidadeNumero;

    history.push({
      pathname: "acompanhamento",
      state: { dadosUnidade: dadosUnidade },
    });
  };

  const alertMsg = () => {
    setAlerta(true);
    setTimeout(() => setAlerta(false), 3000);
  };

  return (
    <>
      <List
        style={{
          padding: "0px 10px 0px 10px",
          borderRight: "2px solid rgb(213, 213, 213)",
          borderBottom: "2px solid rgb(213, 213, 213)",
          borderLeft: "2px solid rgb(213, 213, 213)",
          borderBottomRightRadius: 15,
          borderBottomLeftRadius: 15,
        }}
      >
        <br />

        <div style={{ textAlign: "center" }}>
          <ThemeProvider theme={theme}>
            <Button
              sx={{ color: "#FFFF" }}
              variant="contained"
              onClick={() =>
                history.push({
                  pathname: "acompanhamento",
                  state: { dados: dados },
                })
              }
            >
              <ForumIcon />
              {"  "} Acompanhamento da unidade
            </Button>
          </ThemeProvider>
        </div>
        <br />
        {listaPronuncias.map((pronu, index) => (
          <>
            <ListItem
              sx={{
                width: "100%",
                // bgcolor: "#e8e8e8",
                marginBottom: 2,
                borderRadius: "20px",
              }}
            >
              <ListItemText
                primary={pronu.palavra}
                secondary={
                  <>
                    <Typography
                      sx={{ display: "flex" }}
                      component="span"
                      variant="body2"
                      color="text.primary"
                    >
                      {pronu.traducao}
                    </Typography>

                    {pronu.formaFigurada}
                  </>
                }
              />

              <IconButton
                sx={{ background: "#3D79AD", color: "#FFFF", marginRight: 2 }}
                onClick={() => {
                  setPlay(true);
                  title = pronu.palavra;
                  subtitle = pronu.traducao;
                  subsubtitle = pronu.formaFigurada;
                  playAudio = pronu.audio;
                }}
              >
                <PlayArrowIcon />
              </IconButton>
              <IconButton
                sx={{ background: "#3D79AD", color: "#FFFF" }}
                onClick={() => abrirAcompanhamento(pronu)}
              >
                <ReplyIcon />
              </IconButton>
            </ListItem>
          </>
        ))}
        <Dialog
          onClose={handleClose}
          fullWidth={true}
          open={play}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText
              style={{ textAlign: "center" }}
              id="alert-dialog-description"
            >
              <h4 style={{ fontSize: 16 }}>{title}</h4>
              <h4 style={{ fontSize: 14 }}>{subtitle}</h4>
              <h4 style={{ fontSize: 14, fontStyle: "italic" }}>
                {subsubtitle}
              </h4>
              <br />
              <audio
                autoplay="true"
                style={{ width: 270 }}
                width="270px"
                preload="none"
                src={`${serverHost()}/${playAudio}`}
                controls="controls"
                controlsList="nodownload"
              />
              <br />
              <br />
            </DialogContentText>
          </DialogContent>
          <ThemeProvider theme={theme}>
            <Button
              style={{ margin: "0px 10px 10px 10px" }}
              variant="contained"
              sx={{ color: "#FFFF" }}
              onClick={() => {
                setPlay(false);
              }}
            >
              Fechar
            </Button>
          </ThemeProvider>
        </Dialog>
      </List>
      {alerta && (
        <CustomizedSnackbars texto={text} tipo={tipo}></CustomizedSnackbars>
      )}
    </>
  );
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#3D79AD",
      color: "white",
    },
  },
});
